import { DEFAULT_MARKET, MARKETS } from "../../config.js";
export function getMarketFromDomain(domain) {
  const normalizedDomain = domain.replace(/:[0-9]+$/, "");
  const market = Object.values(MARKETS).find((m) => {
    return normalizedDomain.endsWith(m.domain);
  });
  return market ?? DEFAULT_MARKET;
}
